import React, { useContext } from 'react';
import './ModalBody.css';
import ThemeContext from '../../ThemeContext/ThemeContext';
export default function ModalBody(_ref) {
  var children = _ref.children,
    _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? '' : _ref$alignment,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement("div", {
    className: "_modal__child _dm-modal__body _dm-modal__body--".concat(alignment, " _dm-modal__body--").concat(theme, " auto-modal-body"),
    style: style
  }, children);
}